module.exports = __webpack_public_path__ + "23bc2740a617d0ddafd26542dee3f53e.png";